import React, { useState } from 'react';
import ReportTable from '../components/ReportTable';
import { API_BASE_URL } from '../services/api';

const BrokerReportPage = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [broker, setBroker] = useState('');
  const [results, setResults] = useState([]);
  const [totalBrokerage, setTotalBrokerage] = useState(0);
  const [totalFaceValue, setTotalFaceValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGenerate = async () => {
    setLoading(true);
    setError('');
    try {
      const params = new URLSearchParams();
      if (startDate) params.set('startDate', startDate);
      if (endDate) params.set('endDate', endDate);
      if (broker) params.set('broker', broker);
      const res = await fetch(`${API_BASE_URL}/reports/broker?${params.toString()}`);
      if (!res.ok) throw new Error('Failed to fetch broker report');
      const json = await res.json();
      setResults(json.data || []);
      setTotalBrokerage(json.totalBrokerage || 0);
      setTotalFaceValue(json.totalFaceValue || 0);
    } catch (e) {
      setError(e.message || 'Error fetching broker report');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="broker-report-page ui-page">
      <h2>Broker Report</h2>
      <div style={{ display: 'flex', gap: 16, alignItems: 'flex-end', marginBottom: 16, flexWrap: 'wrap' }}>
        <div>
          <label style={{ display: 'block', fontSize: 13, marginBottom: 4 }}>Start Date</label>
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 13, marginBottom: 4 }}>End Date</label>
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 13, marginBottom: 4 }}>Broker</label>
          <input type="text" placeholder="Filter by broker name" value={broker} onChange={(e) => setBroker(e.target.value)} />
        </div>
        <button type="button" onClick={handleGenerate} disabled={loading}>
          {loading ? 'Loading...' : 'Generate'}
        </button>
      </div>

      {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}

      <ReportTable
        data={results}
        loading={loading}
        error={error}
        reportType="broker"
      />

      {results.length > 0 && (
        <div style={{ marginTop: 16, textAlign: 'right', fontWeight: 600, display: 'flex', justifyContent: 'flex-end', gap: 32 }}>
          <span>Total Face Value: {Number(totalFaceValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
          <span>Total Brokerage: {Number(totalBrokerage).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
        </div>
      )}
    </div>
  );
};

export default BrokerReportPage;
